module.exports = __webpack_public_path__ + "img/menu-mailboxes.6c19f451.svg";